import React from 'react';
import { Plus, Heart, Weight, Thermometer, Activity, Moon, Footprints } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, AreaChart, Area } from 'recharts';
const heartData = [{
  date: 'Feb 1',
  value: 72
}, {
  date: 'Jan 31',
  value: 74
}, {
  date: 'Jan 30',
  value: 71
}, {
  date: 'Jan 29',
  value: 73
}, {
  date: 'Jan 28',
  value: 69
}, {
  date: 'Jan 27',
  value: 75
}, {
  date: 'Jan 26',
  value: 73
}];
const weightData = [{
  date: 'Feb 1',
  value: 68.5
}, {
  date: 'Jan 31',
  value: 68.7
}, {
  date: 'Jan 30',
  value: 68.4
}, {
  date: 'Jan 29',
  value: 68.9
}, {
  date: 'Jan 28',
  value: 68.2
}, {
  date: 'Jan 27',
  value: 68.6
}, {
  date: 'Jan 26',
  value: 68.5
}];
export function Statistics() {
  return <div className="p-8 max-w-7xl mx-auto space-y-8" data-id="element-344">
      {/* Header */}
      <div className="flex justify-between items-end" data-id="element-345">
        <div data-id="element-346">
          <h1 className="text-3xl font-bold text-slate-900" data-id="element-347">
            Health Statistics
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-348">Track your wellness journey</p>
        </div>
        <button className="flex items-center gap-2 bg-slate-800 hover:bg-slate-900 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors" data-id="element-349">
          <Plus className="w-4 h-4" data-id="element-350" /> Log Vitals
        </button>
      </div>

      {/* Vital Selector */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-351">
        <button className="p-4 rounded-xl border-2 border-slate-800 bg-slate-50 flex flex-col items-start gap-3 transition-all" data-id="element-352">
          <Heart className="w-5 h-5 text-red-500" data-id="element-353" />
          <div className="text-left" data-id="element-354">
            <p className="text-xs font-medium text-slate-900" data-id="element-355">Heart Rate</p>
            <p className="text-[10px] text-slate-500 font-bold mt-1" data-id="element-356">--- BPM</p>
          </div>
        </button>
        <button className="p-4 rounded-xl border border-slate-200 bg-white hover:border-blue-300 hover:bg-blue-50 flex flex-col items-start gap-3 transition-all" data-id="element-357">
          <Weight className="w-5 h-5 text-blue-500" data-id="element-358" />
          <div className="text-left" data-id="element-359">
            <p className="text-xs font-medium text-slate-900" data-id="element-360">Weight</p>
            <p className="text-[10px] text-slate-500 font-bold mt-1" data-id="element-361">--- kg</p>
          </div>
        </button>
        <button className="p-4 rounded-xl border border-slate-200 bg-white hover:border-orange-300 hover:bg-orange-50 flex flex-col items-start gap-3 transition-all" data-id="element-362">
          <Thermometer className="w-5 h-5 text-orange-500" data-id="element-363" />
          <div className="text-left" data-id="element-364">
            <p className="text-xs font-medium text-slate-900" data-id="element-365">Temperature</p>
            <p className="text-[10px] text-slate-500 font-bold mt-1" data-id="element-366">--- °C</p>
          </div>
        </button>
        <button className="p-4 rounded-xl border border-slate-200 bg-white hover:border-purple-300 hover:bg-purple-50 flex flex-col items-start gap-3 transition-all" data-id="element-367">
          <Activity className="w-5 h-5 text-purple-500" data-id="element-368" />
          <div className="text-left" data-id="element-369">
            <p className="text-xs font-medium text-slate-900" data-id="element-370">Blood Sugar</p>
            <p className="text-[10px] text-slate-500 font-bold mt-1" data-id="element-371">
              --- mg/dL
            </p>
          </div>
        </button>
        <button className="p-4 rounded-xl border border-slate-200 bg-white hover:border-emerald-300 hover:bg-emerald-50 flex flex-col items-start gap-3 transition-all" data-id="element-372">
          <Footprints className="w-5 h-5 text-emerald-500" data-id="element-373" />
          <div className="text-left" data-id="element-374">
            <p className="text-xs font-medium text-slate-900" data-id="element-375">Steps</p>
            <p className="text-[10px] text-slate-500 font-bold mt-1" data-id="element-376">
              --- steps
            </p>
          </div>
        </button>
        <button className="p-4 rounded-xl border border-slate-200 bg-white hover:border-indigo-300 hover:bg-indigo-50 flex flex-col items-start gap-3 transition-all" data-id="element-377">
          <Moon className="w-5 h-5 text-indigo-500" data-id="element-378" />
          <div className="text-left" data-id="element-379">
            <p className="text-xs font-medium text-slate-900" data-id="element-380">Sleep</p>
            <p className="text-[10px] text-slate-500 font-bold mt-1" data-id="element-381">--- hrs</p>
          </div>
        </button>
      </div>

      {/* Main Chart */}
      <div className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm" data-id="element-382">
        <h3 className="font-bold text-lg text-slate-900 mb-6" data-id="element-383">Heart Rate</h3>
        <div className="h-64 w-full" data-id="element-384">
          <ResponsiveContainer width="100%" height="100%" data-id="element-385">
            <AreaChart data={heartData} data-id="element-386">
              <defs data-id="element-387">
                <linearGradient id="colorHeart" x1="0" y1="0" x2="0" y2="1" data-id="element-388">
                  <stop offset="5%" stopColor="#ef4444" stopOpacity={0.1} data-id="element-389" />
                  <stop offset="95%" stopColor="#ef4444" stopOpacity={0} data-id="element-390" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" data-id="element-391" />
              <XAxis dataKey="date" axisLine={false} tickLine={false} tick={{
              fill: '#94a3b8',
              fontSize: 12
            }} dy={10} data-id="element-392" />
              <YAxis domain={['dataMin - 5', 'dataMax + 5']} axisLine={false} tickLine={false} tick={{
              fill: '#94a3b8',
              fontSize: 12
            }} data-id="element-393" />
              <Tooltip data-id="element-394" />
              <Area type="monotone" dataKey="value" stroke="#ef4444" strokeWidth={2} fillOpacity={1} fill="url(#colorHeart)" data-id="element-395" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Secondary Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-396">
        <div className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm" data-id="element-397">
          <h3 className="font-bold text-lg text-slate-900 mb-6" data-id="element-398">
            Heart Rate Trend
          </h3>
          <div className="h-48 w-full" data-id="element-399">
            <ResponsiveContainer width="100%" height="100%" data-id="element-400">
              <AreaChart data={heartData} data-id="element-401">
                <defs data-id="element-402">
                  <linearGradient id="colorTrend" x1="0" y1="0" x2="0" y2="1" data-id="element-403">
                    <stop offset="5%" stopColor="#ef4444" stopOpacity={0.1} data-id="element-404" />
                    <stop offset="95%" stopColor="#ef4444" stopOpacity={0} data-id="element-405" />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" data-id="element-406" />
                <XAxis dataKey="date" hide data-id="element-407" />
                <YAxis domain={['dataMin - 5', 'dataMax + 5']} hide data-id="element-408" />
                <Tooltip data-id="element-409" />
                <Area type="monotone" dataKey="value" stroke="#ef4444" strokeWidth={2} fill="url(#colorTrend)" data-id="element-410" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm" data-id="element-411">
          <h3 className="font-bold text-lg text-slate-900 mb-6" data-id="element-412">
            Weight Trend
          </h3>
          <div className="h-48 w-full" data-id="element-413">
            <ResponsiveContainer width="100%" height="100%" data-id="element-414">
              <AreaChart data={weightData} data-id="element-415">
                <defs data-id="element-416">
                  <linearGradient id="colorWeight" x1="0" y1="0" x2="0" y2="1" data-id="element-417">
                    <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.1} data-id="element-418" />
                    <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} data-id="element-419" />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" data-id="element-420" />
                <XAxis dataKey="date" hide data-id="element-421" />
                <YAxis domain={['dataMin - 1', 'dataMax + 1']} hide data-id="element-422" />
                <Tooltip data-id="element-423" />
                <Area type="monotone" dataKey="value" stroke="#3b82f6" strokeWidth={2} fill="url(#colorWeight)" data-id="element-424" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Correlation Section */}
      <div className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm" data-id="element-425">
        <div className="flex items-center gap-2 mb-4" data-id="element-426">
          <Activity className="w-5 h-5 text-slate-800" data-id="element-427" />
          <h3 className="font-bold text-lg text-slate-900" data-id="element-428">
            Exercise & Vitals Correlation
          </h3>
        </div>
        <div className="h-32 flex items-center justify-center border-t border-slate-50" data-id="element-429">
          <p className="text-slate-400 text-sm" data-id="element-430">
            Not enough data to show correlation yet.
          </p>
        </div>
      </div>
    </div>;
}